import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=8be9c33e"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports